import i18next from 'i18next';
import { lazy } from 'react';

export const ROUTES = {
  EVENTS: 'events-url',
  BLOGS: 'blogs-url',
  WEBINARS: 'webinars-url',
  OUR_PORTFOLIOS: 'mappable-company-routes.our-product-portfolio-url',
  OUR_PORTFOLIOS_EVENTS: 'our-portofolios-page-event-portofolios-id',
  OUR_PORTFOLIOS_DIGITAL_HUB: 'our-portofolios-page-event-digital-hub-id',
  OUR_PORTFOLIOS_EVENT_TECH: 'our-portofolios-page-event-event-tech-id',
  OUR_TEAM_URL: 'mappable-company-routes.our-team-url',
  ABOUT_US_URL: 'mappable-company-routes.about-us-url',
  CONTACT_URL: 'mappable-company-routes.contact-url',
  IMPRINT_URL: 'mappable-company-routes.imprint-url',
  TERMS_AND_CONDITIONS_URL: 'mappable-company-routes.terms-and-conditions-url',
  CAREER_URL: 'mappable-company-routes.career-url',
  NEWSLETTER_UNSUBSCRIBE_URL:
    'mappable-company-routes.newsletter-unsubscribe-url',
  MULTI_TOUCHPOINT_NETWORKING_URL:
    'mappable-company-routes.multitouchpoint-networking-url',
  DECLARATION_OF_CONSENT_URL:
    'mappable-company-routes.declaration-of-consent-url',
  FAQ_URL: 'mappable-company-routes.faq-url',
  SOCIAL_RESPONSIBILITY_URL:
    'mappable-company-routes.social-responsibility-url',
  PRIVACY_URL: 'https://privacy.we-conect.com',
  HUBS_URL: 'https://hubs101.com',
} as const;

export const getPortfolioDetailsPageUrl = (slug: string) =>
  `${i18next.t('mappable-company-routes.our-product-portfolio-url')}/${slug}`;

export const PortfolioHome = lazy(
  async () => await import('@pages/PortfolioHome')
);

export const PortfolioDetails = lazy(
  async () => await import('@pages/PortfolioDetails')
);

export const OurTeamPage = lazy(async () => await import('@pages/OurTeamPage'));
export const OurProductPortfolioPage = lazy(
  async () => await import('@pages/OurProductPortfolioPage')
);
export const DeclarationOfConsentPage = lazy(
  async () => await import('@pages/DeclarationOfConsentPage')
);
export const EventHome = lazy(async () => await import('@pages/EventHome'));
export const BookNowPage = lazy(async () => await import('@pages/BookNowPage'));
export const BookNowCheckoutPage = lazy(
  async () => await import('@pages/BookNowCheckoutPage')
);
export const IceBreakerPage = lazy(
  async () => await import('@pages/IceBreakerPage')
);
export const EveningNetworkingPage = lazy(
  async () => await import('@pages/EveningNetworkingPage')
);
export const NetworkingDinnerPage = lazy(
  async () => await import('@pages/NetworkingDinnerPage')
);
export const RegisterPage = lazy(
  async () => await import('@pages/RegisterPage')
);

export const WhoAndWhy = lazy(async () => await import('@pages/WhoAndWhy'));
export const Agenda = lazy(async () => await import('@pages/Agenda'));
export const Speakers = lazy(async () => await import('@pages/Speakers'));
export const SpeakerPage = lazy(async () => await import('@pages/SpeakerPage'));
export const Partners = lazy(async () => await import('@pages/Partners'));
export const PartneringPackagesPage = lazy(
  async () => await import('@pages/PartneringPackagesPage')
);
export const PartneringPackagesDetailsPage = lazy(
  async () => await import('@pages/PartneringPackagesDetailsPage')
);
export const PartnerPage = lazy(async () => await import('@pages/PartnerPage'));
export const PastCommunityPage = lazy(
  async () => await import('@pages/PastCommunityPage')
);
export const PDFViewerPage = lazy(
  async () => await import('@pages/PDFViewerPage')
);
export const ClientSidePdfGeneratorPage = lazy(
  async () => await import('@pages/ClientSidePdfGeneratorPage')
);
export const ContentHubPage = lazy(
  async () => await import('@pages/ContentHubPage')
);
export const ContentHubDetailsPage = lazy(
  async () => await import('@pages/ContentHubDetailsPage')
);

export const EventPage = lazy(async () => await import('@pages/EventPage'));
export const Community = lazy(async () => await import('@pages/Community'));
export const PastAttendeeListPage = lazy(
  async () => await import('@pages/PastAttendeeListPage')
);
export const CoLocatedEventsPage = lazy(
  async () => await import('@pages/CoLocatedEventsPage')
);
export const IcebreakerExplanationPage = lazy(
  async () => await import('@pages/IcebreakerExplanationPage')
);
export const ChallengeYourPeersExplanationSpeakersPage = lazy(
  async () => await import('@pages/ChallengeYourPeersExplanationSpeakersPage')
);
export const WorldCafeExplanationForSpeakersPage = lazy(
  async () => await import('@pages/WorldCafeExplanationForSpeakersPage')
);
export const AttendeeMediaKitPage = lazy(
  async () => await import('@pages/AttendeeMediaKitPage')
);
export const BusinessPartnerEventinfoPage = lazy(
  async () => await import('@pages/BusinessPartnerEventinfoPage')
);

export const FAQPage = lazy(async () => await import('@pages/FAQPage'));

export const CareerPage = lazy(async () => await import('@pages/CareerPage'));

export const PrivacyOverviewPage = lazy(
  async () => await import('@pages/PrivacyOverviewPage')
);
export const PrivacyYourDataPage = lazy(
  async () => await import('@pages/PrivacyYourDataPage')
);
export const PrivacyTakeControlPage = lazy(
  async () => await import('@pages/PrivacyTakeControlPage')
);
export const PrivacySecurityPage = lazy(
  async () => await import('@pages/PrivacySecurityPage')
);
export const PrivacyAntiSpamPolicyPage = lazy(
  async () => await import('@pages/PrivacyAntiSpamPolicyPage')
);
export const PrivacyPolicyPage = lazy(
  async () => await import('@pages/PrivacyPolicyPage')
);
export const PrivacyPolicyFacebookPage = lazy(
  async () => await import('@pages/PrivacyPolicyFacebookPage')
);
export const PrivacyContactUsPage = lazy(
  async () => await import('@pages/PrivacyContactUsPage')
);
export const NewsletterUnsubscribePage = lazy(
  async () => await import('@pages/NewsletterUnsubscribePage')
);
export const MultiTouchpointNetworkingPage = lazy(
  async () => await import('@pages/MultiTouchpointNetworkingPage')
);
export const TermsAndConditionsPage = lazy(
  async () => await import('@pages/TermsAndConditionsPage')
);
export const OurAwardsPage = lazy(
  async () => await import('@pages/OurAwardsPage')
);
export const AboutUsPage = lazy(async () => await import('@pages/AboutUsPage'));
export const SocialResponsibilityPage = lazy(
  async () => await import('@pages/SocialResponsibilityPage')
);
export const ContactPage = lazy(async () => await import('@pages/ContactPage'));
export const ImprintPage = lazy(async () => await import('@pages/ImprintPage'));
export const EventContactPage = lazy(
  async () => await import('@pages/EventContactPage')
);

export const HelmetPage = lazy(async () => await import('@pages/HelmetPage'));
export const WebinarPage = lazy(async () => await import('@pages/WebinarPage'));
export const NotFound = lazy(async () => await import('@pages/NotFound'));
export const EventNotFound = lazy(
  async () => await import('@pages/EventNotFound')
);

export const AwardsPage = lazy(async () => await import('@pages/AwardsPage'));

export const VendorOnsiteRegistrationPage = lazy(
  async () => await import('@pages/VendorOnsiteRegistrationPage')
);

export const YearlySurveyPage = lazy(
  async () => await import('@pages/YearlySurveyPage')
);

export const BPPackagesRegPage = lazy(
  async () => await import('@pages/BPPackagesRegPage')
);

export const EventGuideUpdatePage = lazy(
  async () => await import('@pages/EventGuideUpdatePage')
);

export const AttendeeListRegPage = lazy(
  async () => await import('@pages/AttendeeListRegPage')
);
export const PastAttendeeListRegPage = lazy(
  async () => await import('@pages/PastAttendeeListRegPage')
);

export const OfferDownloadPage = lazy(
  async () => await import('@pages/OfferDownloadPage')
);

export const MktVipPassPage = lazy(
  async () => await import('@pages/MktVipPassPage')
);

export const BookingTeamPass = lazy(
  async () => await import('@pages/BookingTeamPass')
);

export const VipClientTicket = lazy(
  async () => await import('@pages/BpVipClientTicket')
);
export const OemTicketPage = lazy(
  async () => await import('@pages/OemTicketPage')
);

export const MultiTouchpointNetworkingPageEvent = lazy(
  async () => await import('@pages/MultiTouchpointNetworkingPageEvent')
);
